
const sltMaster = '/slt/api/master/secure/jas/';
const sltShopOrder = '/slt/api/shop/order/secure/jas/';
const lupExternal ='/lup/alinea-external-interfaces-service/'


export class SltMasterEndpoints {
    public static getGeoGroups = `${sltMaster}reference/property/find-property`;
    // public static getGeoGroups = `${sltMaster}reference/property/find-property?propertyType=APPOINTMENT_SCHEDULE_REGIONS&businessSegmentId=1`;
    public static companyCommunicationProfile = `${sltMaster}company-communication-profile`;
    public static findCommodityGroup = `${sltMaster}product-group/find-product-group`;
    public static findLocation = `${sltMaster}location/find-location`;
    public static findLocations = `${sltMaster}location/find-locations`;
    public static getLocationInfo = `${sltMaster}location/get-location-information`;
    public static getPickDropDeliveryLocation = `slt/api/master/secure/jas/location/find-ramp-and-pstl-city-location`;
    public static findProperty = `${sltMaster}reference/property/find-property`;
    public static findReasonCodes = `${sltMaster}reasoncode/find-reason-codes`;
    // public static findReasonCodes = `${sltMaster}reasoncode/find-reason-codes?reasonType=RATE UPDT&activeFlag=true`;
    public static findUser = `${sltMaster}user/find-user`;
    public static findGeoGroup = `${sltMaster}geo-group/find-geo-group`;
    public static getCompany = `${sltMaster}company/get-company`;
    public static searchBrand = `${sltMaster}reference/property/search-brand`;
    public static searchProperty = `${sltMaster}reference/property/search-property`;

    public static findProductAssociations = `${sltMaster}product/find-product-associations`;
    public static findProduct = `${sltMaster}product/find-product`;
    public static getProduct = `${sltMaster}product/get-product/`;
    public static findProductByProductCodes = `${sltMaster}product/find-product-by-product-codes`;
    public static findWarehouseLocations = `${sltMaster}location/find-warehouse-locations`;


    
    public static GET_COMPANY = `${sltMaster}company/get-company`;
    public static GET_LOCATION_BY_ID = `${sltMaster}location/get-location`;
    public static GET_LOCATION_INFO_BY_ID = `${sltMaster}location/get-location-information`;
    public static FIND_COMPANY_LOCATIONS = `${sltMaster}company/get-associated-locations`;
    public static GET_COMPANY_DETAILS = `${sltMaster}company/get-company-details`;
    public static FIND_PROPERTY = `${sltMaster}reference/property/find-property`;
    public static FIND_GEO_GROUP = `${sltMaster}geo-group/find-geo-group`;
    public static FIND_TRAIN_SCHEDULE = `${sltMaster}train-schedule/find-segments-with-schedule`;
    public static VIEW_PENDING_TRAIN_INSNTACES = `${sltMaster}train/view-pending-train-instances`;
    public static findSegmentsWithOutSchedule = `${sltMaster}train-schedule/find-segments-without-schedule`;
    public static findSchedulesforSegment = `${sltMaster}train-schedule/get-train-schedule`;
    public static CREATE_TRAIN_SCHEDULE = `${sltMaster}train-schedule/create-train-schedules`;
    public static FIND_COMMUNICATION_PROFILE = `${sltMaster}company-communication-profile/find-company-communication-profile`;
    public static UPDATE_COMMUNICATION_PROFILE = `${sltMaster}company-communication-profile/update-company-communication-profile`;
    public static UPDATE_TRAIN_SCHEDULE = `${sltMaster}train-schedule/update-schedules`;
    public static DELETE_TRAIN_SCHEDULE = `${sltMaster}train-schedule/deactivate-schedules`;
    public static SEND_ALL_TRAINS_TO_PRIYA = `${sltMaster}train/review-train-instance`;
    public static FIND_PRODUCT_ASSOCIATIONS = `${sltMaster}product/find-product-associations`;
    public static FIND_LOCATION = `${sltMaster}location/find-location`; // searchTerm=sea
    public static GET_COMPANY_LOCATION_INFO = `${sltMaster}company/get-company-location-info`; // /{compLocaId}
    public static UPDATE_COMPANY_LOCATION_INFO = `${sltMaster}company/update-company-location-info`;
    public static UNLINK_COMPANY_LOCATION_INFO = `${sltMaster}company/delete-location-association`;

    public static FIND_PRODUCT = `${sltMaster}product/find-product`;
    public static DELETE_PRODUCT_ASSOCIATION = `${sltMaster}product/delete-product-association`;
    public static UPDATE_PRODUCT_ASSOCIATION = `${sltMaster}product/update-product-association`;
    public static CREATE_PRODUCT_ASSOCIATION = `${sltMaster}product/create-product-association`;
    public static GET_EQUIPMENT_ID = `${sltMaster}equipment/find-by-name`;
    public static UPDATE_EDI_CODE = `${sltMaster}company/update-edi-code`;
    public static DELETE_LOCATION_ASSOCIATION = `${sltMaster}company/delete-location-association`;
    public static CREATE_LOCATION_ASSOCIATION = `${sltMaster}company/create-location-association`;
    public static FIND_VENDOR_MASTER = `${sltMaster}company/find-vendor-master`;
    public static FIND_CUSTOMER_MASTER = `${sltMaster}company/find-customer-master`;
    // Order services
    public static GET_CUSTOMER_ACCOUNT_INFO = `${sltShopOrder}get-customer-account-info`;
    public static FIND_COMPANY_HOURS_INFO = `${sltMaster}company/get-location-service-hours`; // searchTerm=sea
    public static GET_EDI_CODE = `${sltMaster}company/get-edi-code`; // searchTerm=sea
    public static UPDATE_LOCATION = `${sltMaster}location/update-location-info`; // searchTerm=sea
    public static GET_LOCATION_ROLE_TYPES = `${sltMaster}location/get-location-role-types`;
    public static FIND_FIRM_NUMBER_LOCATIONS = `${sltMaster}location/get-locations-by-firm-numbers`;
    public static FIND_METRO_LOCATIONS =  `${sltMaster}area/search-area-like/`;
    public static GET_SERVING_AREAS = `${sltMaster}area/get-all-serving-areas`;

    public static FIND_CONSTRAINT_LOCATIONS =  `${sltMaster}location/find-pstl-city-location-by-type`;

    public static FIND_CITY_POSTAL_CODE_LOCATIONS =  `${sltMaster}location/find-pstl-city-location?`;

    public static FIND_DRAY_CARRIER_LOOKUP = `${sltMaster}location/dray-carrier-lookup`;
    public static FIND_CARLOAD_VENDOR_LOOKUP = `${sltMaster}location/carload-vendor-lookup`;
    
    public static GET_RAIL_CARRIERS = `${sltMaster}location/get-rail-carriers`;

    public static GET_ALL_RAIL_RAMPS = `${sltMaster}location/get-all-ramp-locations`;
    
    public static FIND_LOCATION_LOOKUP_BY_PLANT_CODE = `${sltMaster}location/location-lookup-by-plant-code`;
   
    public static FIND_CITY_STATE_COUNTRY_EXTERNAL = `${lupExternal}transload/find-matching-locations/1.0`;
    public static FIND_TRANSLOAD_VENDORS = `${lupExternal}transload/find-nearby-transload-vendors/1.0`;
    public static FIND_KEY_VALUE = `${lupExternal}transload/get-key-values/1.0`;
    
}
